<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

addEventListener("DOMContentLoaded", (event) => { 
    let title = document.querySelectorAll('.title .text')
    for(let i=0; i<title.length; i++){
        let lastWord = '';
        let words = title[i].innerHTML.split(" ");
        var newStr = ''
        for(let i=0; i<words.length; i++){
            if(words[i].length > 1){
                newStr += words[i] + " "    
                lastWord = words[i]               
            }
        }
        newStr = newStr.split(" ").slice(0, -1).join(" ");
        newStr = newStr.split(" ").slice(0, -1).join(" ");
        title[i].innerHTML = newStr + ' <i>' + lastWord + '</i>'
    }
})
